module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm_head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062856616_Cover#cover",
      "id": "rcover"
    }
  }, [_c('i', [_vm._v("Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062856616_Titlepage#title",
      "id": "rtitle"
    }
  }, [_c('i', [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062856616_Dedication#_idParaDest-1",
      "id": "r_idParaDest-1"
    }
  }, [_c('i', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "con1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062856616_Chapter_1#_idParaDest-3",
      "id": "r_idParaDest-3"
    }
  }, [_vm._v("The Border Fox")])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062856616_Chapter_2#_idParaDest-4",
      "id": "r_idParaDest-4"
    }
  }, [_vm._v("The Boatman")])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Chapter_3#_idParaDest-5",
      "id": "r_idParaDest-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ruins")])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Chapter_4#_idParaDest-6",
      "id": "r_idParaDest-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beginish")])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Chapter_5#_idParaDest-7",
      "id": "r_idParaDest-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love is Strange")])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Chapter_6#_idParaDest-8",
      "id": "r_idParaDest-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Sense of Rain")])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Chapter_7#_idParaDest-9",
      "id": "r_idParaDest-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildflowers")])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Chapter_8#_idParaDest-10",
      "id": "r_idParaDest-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Segovia")])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Chapter_9#_idParaDest-11",
      "id": "r_idParaDest-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Chapter_10#_idParaDest-12",
      "id": "r_idParaDest-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fine Feathers")])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Chapter_11#_idParaDest-13",
      "id": "r_idParaDest-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Chapter_12#_idParaDest-14",
      "id": "r_idParaDest-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Death in the Family")])]), _vm._v(" "), _c('p', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Acknowledgements#_idParaDest-15",
      "id": "r_idParaDest-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#_idParaDest-16",
      "id": "r_idParaDest-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Also_by#_idParaDest-17",
      "id": "r_idParaDest-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Also by Billy O’Callaghan")])])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062856616_Copyright#_idParaDest-19",
      "id": "r_idParaDest-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#_idParaDest-20",
      "id": "r_idParaDest-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Publisher")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e40b40a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062856616_Contents.vue
// module id = 66
// module chunks = 0